import React from "react";
import { FaBars } from "react-icons/fa";
import {
  Nav,
  NavBarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinks,
} from "./NavElements";
import Logo from "../logo/Logo";

const LINKS = [
  { to: "/projects", label: "Portfolio" },
  { to: "/builders", label: "Founders" },
  { to: "/team", label: "Team" },
];

export default function NavBar({ toggle }) {
  return (
    <Nav>
      <NavBarContainer>
        {/* disabledLink keeps Logo from rendering its own <a> inside this one */}
        <NavLogo to="/" aria-label="Vitalforce home">
          <Logo disabledLink />
        </NavLogo>

        <MobileIcon onClick={toggle} aria-label="Open menu">
          <FaBars />
        </MobileIcon>

        <NavMenu>
          {LINKS.map(({ to, label }) => (
            <NavItem key={to}>
              <NavLinks to={to}>{label}</NavLinks>
            </NavItem>
          ))}
        </NavMenu>
      </NavBarContainer>
    </Nav>
  );
}
